import { useRouter } from 'next/router';
import type React from 'react';
import { Page as Component } from '~/components/specifics/vendors/settings/company_settings/construction_item_settings/Page';

export const Page: React.FC = () => {
  const router = useRouter();
  const { companyMasterId = null } = router.query;
  if (companyMasterId === null) return null;

  return <Component companyMasterId={Number(companyMasterId)} />;
};
